export const SLIDE_DURATION_MS = 5000


// WEBPACK FOOTER //
// ./src/templates/components/base/stories/const.js